/** Wait for an exact seek and some decoded data before starting the shared clock. */
export function preparePlayback(media: HTMLMediaElement, target: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    let timeout: ReturnType<typeof setTimeout>;
    const events = ["loadedmetadata", "loadeddata", "canplay", "seeked", "error"];
    const finish = (error?: Error) => {
      clearTimeout(timeout);
      for (const event of events) media.removeEventListener(event, check);
      signal.removeEventListener("abort", abort);
      if (error) reject(error); else resolve();
    };
    const abort = () => finish(new DOMException("Playback cancelled", "AbortError"));
    const check = () => {
      if (signal.aborted) { abort(); return; }
      if (media.error) { finish(new Error(media.error.message || "Video could not load")); return; }
      if (media.readyState < 1) return;
      const end = Number.isFinite(media.duration) ? Math.max(0, media.duration - 0.001) : Infinity;
      const want = Math.min(end, Math.max(0, target));
      if (Math.abs(media.currentTime - want) > 0.005) { media.currentTime = want; return; }
      if (!media.seeking && media.readyState >= 3) finish();
    };
    media.pause();
    media.preload = "auto";
    for (const event of events) media.addEventListener(event, check);
    signal.addEventListener("abort", abort, {once: true});
    timeout = setTimeout(() => finish(new Error("Video is taking too long to load. Try playing again.")), 20000);
    if (media.networkState === 0) media.load();
    check();
  });
}
